export default __webpack_public_path__ + "img/text-box.c91cf07f.svg";